import { render, staticRenderFns } from "./subSymptomConfig.vue?vue&type=template&id=69f3995b&scoped=true"
import script from "./subSymptomConfig.vue?vue&type=script&lang=ts"
export * from "./subSymptomConfig.vue?vue&type=script&lang=ts"
import style0 from "./subSymptomConfig.vue?vue&type=style&index=0&id=69f3995b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f3995b",
  null
  
)

export default component.exports